import * as React from 'react';
import FilterWrapper from '../../FilterWrapper';
import { useChartBridge } from '../../ChartBridgeContext';

// Sidebar control for the `kind: "axis-switcher"` filter. Unlike the other
// filters it is NOT a search facet: it does not narrow the result set, it
// switches which data field feeds the chart's X axis. Options are published by
// HitsWidget from the current rows, so the control stays hidden until there is
// more than one field to pick.
export function AxisSwitcherFilter({ label }) {
  const { options, selected, setSelected } = useChartBridge();

  if (options.length < 2) return null;

  return (
    <FilterWrapper label={label} attribute='axis-switcher' kind='dropdown'>
      <select
        className='nv-chart__facet-select'
        aria-label={label}
        value={selected ?? options[0].value}
        onChange={(event) => setSelected(event.target.value)}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </FilterWrapper>
  );
}
